import {
  AppActionTypes,
  fetchAppConfigFailure,
  FetchAppConfigRequestAction,
  fetchAppConfigSuccess,
  UpdateAppConfigRequestAction,
  updateAppConfigSuccess,
} from "actions";
import { IAppConfig } from "interfaces/app-config.interface";
import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { LocalStorageKeys } from "utils/constants";

const fetchAppConfig = async () => {
  const config = localStorage.getItem(LocalStorageKeys.AppConfigKey);

  // create if not exits
  if (!config) {
    const defaultConfig: IAppConfig = {
      theme: "light",
    };
    localStorage.setItem(
      LocalStorageKeys.AppConfigKey,
      JSON.stringify(defaultConfig)
    );
    return defaultConfig;
  }

  return JSON.parse(config);
};

const updateAppConfig = async (config: IAppConfig) => {
  localStorage.setItem(LocalStorageKeys.AppConfigKey, JSON.stringify(config));
  return config;
};

// Worker Saga
function* fetchAppConfigData(
  action: FetchAppConfigRequestAction
): SagaIterator {
  try {
    const response: IAppConfig = yield call(fetchAppConfig);
    yield put(fetchAppConfigSuccess(response));
  } catch (error: any) {
    yield put(fetchAppConfigFailure(error.message || "Unknown error occurred"));
  }
}

// Worker Saga for CHANGE_THEME
function* updateAppConfigData(
  action: UpdateAppConfigRequestAction
): SagaIterator {
  try {
    const config = action.payload;
    const response: IAppConfig = yield call(updateAppConfig, config);
    yield put(updateAppConfigSuccess(response));
  } catch (error: any) {
    yield put(fetchAppConfigFailure(error.message || "Unknown error occurred"));
  }
}

// Watcher Saga
export function* watchAppSaga() {
  yield takeLatest(AppActionTypes.FETCH_APP_CONFIG_REQUEST, fetchAppConfigData);
  yield takeLatest(
    AppActionTypes.UPDATE_APP_CONFIG_REQUEST,
    updateAppConfigData
  );
}
